export default __webpack_public_path__ + "static/media/youtube.c5d40fb3.png";